import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@wds/box';
import { FormField } from '@wds/form-group'
import { Input } from '@wds/input';
import { Typography } from '@wds/typography';
import { Textarea } from '@wds/textarea';
import { Checkbox } from '@wds/checkbox';

export const fieldTypes = Object.freeze({
	input: 1,
	textArea: 2,
	checkbox: 3,
});

const FormikInput = ({
	fieldType,
	containerClassName,
	id,
	type,
	inputClassName,
	label,
	value,
	onChange,
	error,
	required,
	...props
}) => {
	const labelNode = (
		<div>
			{label}
			{!required && (<span className="sma-label-optional">{gettext(' (optional)')}</span>)}
		</div>
	);
	return (
		<FormField className={containerClassName}>
			{fieldType === fieldTypes.input && (
				<Input
					stretched
					id={id}
					type={type}
					label={labelNode}
					color={error && !error.required ? 'error' : null}
					value={value}
					onChange={onChange}
					{...props}
				/>
			)}
			{fieldType === fieldTypes.textArea && (
				<Textarea
					stretched
					id={id}
					type={type}
					label={labelNode}
					color={error && !error.required ? 'error' : null}
					value={value}
					onChange={onChange}
					{...props}
				/>
			)}
			{fieldType === fieldTypes.checkbox && (
				<Checkbox
					id={id}
					label={label}
					checked={value}
					onChange={onChange}
					{...props}
				/>
			)}
			{error && error !== {} && !error.required && (
				<Box mt={1}>
					<Typography color="error" component="p">
						{error}
					</Typography>
				</Box>
			)}
		</FormField>
	);
};

FormikInput.propTypes = {
	fieldType: PropTypes.number.isRequired,
	containerClassName: PropTypes.string,
	id: PropTypes.string,
	type: PropTypes.string,
	label: PropTypes.string,
	inputClassName: PropTypes.string,
	// Prop type any is used here because value can be any type
	/* eslint-disable react/forbid-prop-types */
	value: PropTypes.any,
	onChange: PropTypes.func,
	error: PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.string,
		// Object is passed in to indicate required error, because it is
		// needed for validation but should not be displayed to the user
		PropTypes.shape({ required: PropTypes.bool.isRequired }),
	]),
	required: PropTypes.bool,
};
FormikInput.defaultProps = {
	containerClassName: '',
	id: '',
	type: '',
	label: '',
	inputClassName: '',
	value: '',
	onChange: () => null,
	error: null,
	required: false,
};

export default FormikInput;
